<template>
  <v-menu
    v-model="dialog"
    min-width="20rem"
    max-width="25rem"
    open-on-hover
    :close-on-content-click="false"
    :nudge-width="200"
    :offset-x="$vuetify.breakpoint.smAndUp"
    :offset-y="$vuetify.breakpoint.xsOnly"
  >
    <template v-slot:activator="{ on }">
      <tr v-on="on" style="padding-bottom: 2px;">
        <slot></slot>
      </tr>
    </template>
    <v-card>
      <v-card-title class="px-1 pt-1">
        <v-row justify="space-between" no-gutters>
          <span class="font-capitalize subtitle-1 ml-2">{{
            getProductName
          }}</span>
        </v-row>
      </v-card-title>
      <v-card-text v-if="loading">
        <v-row align="center" justify="center" no-gutters class="my-3">
          <v-progress-circular indeterminate></v-progress-circular>
        </v-row>
      </v-card-text>
      <v-card-text v-else>
        <v-hover v-slot="{ hover }">
          <div v-if="correction" class="my-1">
            <v-row dense align="center" no-gutters>
              <span class="overline text--primary">Commentaire</span>
            </v-row>

            <v-row dense no-gutters>
              <span v-show="!hover" class="heading-6 text--primary">{{
                correction.comments
              }}</span>
              <v-textarea
                v-show="hover"
                dense
                filled
                class="no-before"
                auto-grow
                :rows="1"
                :value="correction.comments"
                @change="v => setCorrectionComment(v)"
              ></v-textarea>
            </v-row>
          </div>
        </v-hover>
        <v-row
          align="center"
          justify="space-between"
          no-gutters
          v-if="beforeInventory && latestInventory"
          class="f-nw my-1"
        >
          <span class="overline">Inventaire avant correction</span>
          <span class="heading-6">{{
            beforeInventory.computedQuantity | round2
          }}</span>
        </v-row>
        <!-- <v-row
          align="center"
          justify="space-between"
          no-gutters
          v-if="beforeInventory && latestInventory"
          class="f-nw my-1"
        >
          <span class="overline">Productions entre inventaires</span>
          <span class="heading-6">{{ getProduction }}</span>
        </v-row>
        <v-row
          align="center"
          justify="space-between"
          no-gutters
          v-if="beforeInventory && latestInventory"
          class="f-nw my-1"
        >
          <span class="overline">Consommations entre inventaires</span>
          <span class="heading-6">{{ getConsomation }}</span>
        </v-row> -->
        <v-row
          align="center"
          justify="space-between"
          no-gutters
          v-if="beforeInventory && latestInventory"
          class="f-nw my-1"
        >
          <span class="overline">Inventaire après vérification</span>
          <span class="heading-6">{{ latestInventory.quantity | round2 }}</span>
        </v-row>
        <v-row
          align="center"
          justify="space-between"
          no-gutters
          v-if="beforeInventory && latestInventory"
          class="f-nw my-1"
        >
          <span class="overline">Écart d'inventaire</span>
          <span class="heading-6">{{ correction.quantity | round2 }}</span>
        </v-row>
        <v-row
          align="center"
          justify="space-between"
          no-gutters
          v-if="beforeInventory && latestInventory"
          class="f-nw my-1"
        >
          <span class="overline">Inventaire actuel</span>
          <span class="heading-6">{{
            latestInventory.computedQuantity | round2
          }}</span>
        </v-row>
        <v-tooltip top max-width="20rem" v-if="correctionValue">
          <template v-slot:activator="tooltip">
            <v-row
              align="center"
              justify="space-between"
              no-gutters
              class="f-nw my-1"
              v-on="tooltip.on"
            >
              <span class="overline">Correction moyenne</span>
              <span class="heading-6"
                >{{ (Number(correctionValue.value) * 100) | round2 }} %</span
              >
            </v-row>
          </template>
          <span v-if="correctionValue.value < 0"
            >Signifie qu'en moyenne la production consomme en moyenne
            {{ Math.abs(Number(correctionValue.value) * 100) | round2 }}% plus
            du produit que ce qui est planifié</span
          >
          <span v-if="correctionValue.value > 0"
            >Signifie qu'en moyenne la production consomme en moyenne
            {{ Math.abs(Number(correctionValue.value) * 100) | round2 }}% moins
            du produit que ce qui est planifié</span
          >
        </v-tooltip>
        <v-row
          v-if="valuePrediction"
          align="center"
          justify="space-between"
          no-gutters
          class="f-nw my-1"
        >
          <span class="overline">Correction sur 14 jours</span>
          <span class="heading-6">{{
            correctionValue.quantity_sum | round2
          }}</span>
        </v-row>
        <v-row
          v-if="valuePrediction"
          align="center"
          justify="space-between"
          no-gutters
          class="f-nw my-1"
        >
          <span class="overline">Valeur sur 1ans</span>
          <span class="heading-6">{{ valuePrediction }}$</span>
        </v-row>

        <v-row class="mt-3" align="center" justify="space-between">
          <v-btn
            text
            small
            @click="
              $router.push({ name: 'StatisticsDetails', params: { id: id } })
            "
          >
            <v-icon small left>far fa-chart-bar</v-icon>
            Détails
          </v-btn>
          <v-tooltip left>
            <template v-slot:activator="{ on }">
              <v-btn
                class="mr-2"
                v-on="on"
                icon
                text
                :color="getIsPinned === true ? 'success' : ''"
                @click="toggleIsPinned"
              >
                <v-icon>fa-eye</v-icon>
              </v-btn>
            </template>
            Surveiller ce produit
          </v-tooltip>
        </v-row>
      </v-card-text>
    </v-card>
  </v-menu>
</template>

<script>
import { api } from "@/api";
import { round10 } from "round10";
import moment from "moment";
import { mapGetters } from "vuex";
export default {
  name: "ProductSummaryDialog",
  props: {
    id: {
      required: true
    },
    corr: {
      default: null
    }
  },
  computed: {
    ...mapGetters(["getProducts", "getRecipes"]),
    getProductName() {
      const p = this.getProducts.find(x => x.id === this.productId);
      if (p) {
        return p.nom;
      } else {
        return "";
      }
    },
    getProduction() {
      return round10(
        this.transactions
          .map(x => Number(x.quantity))
          .filter(x => x > 0)
          .reduce((a, b) => a + b, 0),
        -2
      );
    },
    getConsomation() {
      return round10(
        this.transactions
          .map(x => Number(x.quantity))
          .filter(x => x < 0)
          .reduce((a, b) => a + b, 0),
        -2
      );
    },
    getIsPinned() {
      const p = this.getProducts.find(x => x.id === this.productId);
      if (p) {
        return p.data.is_pinned;
      } else {
        return false;
      }
    }
  },
  data() {
    return {
      productId: undefined,
      dialog: false,
      loading: false,
      latestInventory: undefined,
      beforeInventory: undefined,
      transactions: [],
      correction: undefined,
      correctionValue: undefined,
      valuePrediction: undefined
    };
  },
  methods: {
    openDialog() {
      this.productId = this.id;
      this.dialog = true;
      this.getData();
    },
    async getData() {
      try {
        this.loading = true;
        let correction = undefined;
        if (this.corr === null) {
          const res = await api.getInventoryRecordsCorrections({
            product: this.productId,
            take: 1
          });
          if (res.length > 0) {
            correction = res[0];
          }
        } else {
          correction = this.corr;
        }

        if (correction) {
          this.correction = correction;
          const date = moment(this.correction.created);
          const latestInventory = await api.getInventoryRecords({
            product: this.productId,
            latest: true
          });
          this.latestInventory =
            latestInventory.length > 0 ? latestInventory[0] : undefined;
          const beforeInventory = await api.getInventoryRecords({
            product: this.productId,
            date: date.subtract(1, "m").format("YYYY-MM-DDTHH:mm:ss.SSSSSSZ"),
            latest: true
          });
          this.beforeInventory =
            beforeInventory.length > 0 ? beforeInventory[0] : undefined;
          const transactions = await api.getInventoryTransactions({
            product: this.productId,
            start:
              this.beforeInventory !== undefined
                ? moment(this.beforeInventory.created).format(
                    "YYYY-MM-DDTHH:mm:ss.SSSSSSZ"
                  )
                : null,
            end:
              this.latestInventory !== undefined
                ? moment(this.latestInventory.created)
                    .subtract(1, "m")
                    .format("YYYY-MM-DDTHH:mm:ss.SSSSSSZ")
                : null
          });
          this.transactions = transactions.map(x => {
            return { ...x, groupDate: moment(x.date).format("YYYY-MM-DD") };
          });
          const correctionValue = await api.getInventoryCorrectionValues({
            product: this.productId
          });
          this.correctionValue =
            correctionValue.length > 0 ? correctionValue[0] : undefined;

          if (this.correctionValue) {
            const p = this.getProducts.find(x => x.id === this.productId);
            if (p) {
              this.valuePrediction = round10(
                (this.correctionValue.quantity_sum / 2) *
                  Number(p.data.prix_inventory) *
                  52,
                -2
              );
            }
          }
        } else {
          this.dialog = false;
        }
      } finally {
        this.loading = false;
      }
    },
    async toggleIsPinned() {
      const product = this.getProducts.find(x => x.id === this.productId);
      if (product) {
        if (product.est_intermediaire === true) {
          const recipe = this.getRecipes.find(
            x => x.fk_produit_intermediaire === this.productId
          );
          if (recipe) {
            const d = {
              ...recipe
            };
            d.data.is_pinned = !product.data.is_pinned;
            await api.patchRecipe(recipe.id, d);
            this.$store.dispatch("loadRecipes");
            this.$store.dispatch("loadProducts");
          }
        } else {
          const d = {
            ...product
          };
          d.data.is_pinned = !product.data.is_pinned;
          await api.patchRecipeProduct(this.productId, d);
          this.$store.dispatch("loadProducts");
        }
      }
    },
    async setCorrectionComment(v) {
      if (v) {
        this.correction.comments = v;
        const data = {
          id: this.correction.id,
          comments: v
        };
        await api.patchInventoryRecordsCorrections(this.correction.id, data);
      }
    }
  },
  watch: {
    dialog(v) {
      if (v === true) {
        this.productId = this.id;
        if (this.loading === false) this.getData();
      }
    }
  }
};
</script>

<style></style>
